import styled, { css } from "styled-components";

import { Check } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { BaseFlex, CenteredFlexRow, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const ellipsisMultiLine = (lines: number = 2) => css`
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: ${lines};
    -webkit-box-orient: vertical;
`;

export const CheckmarkIcon = styled(Check)`
    width: 20px;
    height: 20px;
    flex-shrink: 0;

    svg {
        height: 8.5px;
        width: 11px;
    }
`;

export const Container = styled(BaseFlex)`
    width: 100%;
    justify-content: center;
    gap: 16px;
`;

export const Card = styled.div<{ isRecommended: boolean }>`
    background: ${colorsPalettes.carbon["0"]};
    border-radius: ${({ isRecommended }) => (isRecommended ? "0 0 12px 12px" : "12px")};
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    padding: 24px 12px;
    width: 40%;
    position: relative;
    &:hover {
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    }
`;

export const TagContainer = styled(CenteredFlexRow)`
    position: absolute;
    top: -20px;
    left: 0;
    width: 100%;
    background-color: ${colorsPalettes.blue[400]};
    border-radius: 16px 16px 0 0;
    height: 20px;
`;

export const Tag = styled(Text)``;

export const Title = styled(Text)``;

export const Subtitle = styled(Text)`
    margin-bottom: 32px;
    ${ellipsisMultiLine(1)};
`;

export const DueToday = styled(Text)``;

export const Price = styled(Text)`
    display: block;
    align-items: center;
    gap: 4px;
    margin: 4px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
`;

export const FeatureList = styled(FlexColumn)`
    margin-top: 32px;
    gap: 8px;
`;

export const Feature = styled(BaseFlex)`
    gap: 4px;
`;

export const FeatureText = styled(Text)``;
